import type { DataResponse, TodayAnniversary, TodayBirthday } from '@pms/shared';
import { api } from '@/lib/api';

export const dashboardService = {
  async getTodayBirthdays(): Promise<TodayBirthday[]> {
    const res = await api.get<DataResponse<TodayBirthday[]>>('/dashboard/birthdays/today');
    return res.data.data;
  },

  async getTodayAnniversaries(): Promise<TodayAnniversary[]> {
    const res = await api.get<DataResponse<TodayAnniversary[]>>('/dashboard/anniversaries/today');
    return res.data.data;
  },
};
